import { Backdrop, CircularProgress } from "@mui/material";

export interface DefaultBackdropProps {
    open: boolean
}

export default function DefaultBackdrop(props: DefaultBackdropProps) {
    return (
        <Backdrop
            sx={{ color: 'common.white', zIndex: (theme) => theme.zIndex.modal + 1 }}
            open={props.open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>);
}